import React, { useEffect, useState } from "react";
import { useUnidades } from "../../hooks/test/useUnidades";
import Swal from "sweetalert2";
import { Spinner } from "../../components/Spinner";
import moment from "moment";
import "moment/locale/es-mx";

export const TableroClientes = () => {
  const { getNegocios, postNegocios } = useUnidades();

  const [negocios, setNegocios] = useState([]);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [nombreCliente, setNombreCliente] = useState(null);
  const [isButtonDisabled, setIsButtonDisabled] = useState(false);

  useEffect(() => {
    loadData();
  }, []);

  const loadData = async () => {
    let resp = await getNegocios();
    if (resp.ok) setNegocios(resp.negocios);
  };

  const handleFileUpload = (event) => {
    setSelectedFile(event.target.files[0]);
  };

  const saveClient = async (event) => {
    event.preventDefault();
    setLoading(true);
    setIsButtonDisabled(true);

    if (nombreCliente === null) {
      setLoading(false);
      setIsButtonDisabled(false);
      Swal.fire({
        title: "Requerido",
        text: "Por favor introduce el nombre del cliente",
        icon: "info",
      });
    } else if (selectedFile === null) {
      setLoading(false);
      setIsButtonDisabled(false);
      Swal.fire({
        title: "Requerido",
        text: "Por favor selecciona un archivo",
        icon: "info",
      });
    } else {
      let formData = new FormData();
      formData.append("archivo", selectedFile);
      formData.append("negocio_nombre", nombreCliente);

      let resp = await postNegocios(formData);

      if (resp.ok) {
        setLoading(false);
        Swal.fire({
          title: "NEGOCIO",
          text: resp.msg,
          showConfirmButton: false,
          icon: "success",
          timer: 3000,
        });
        loadData();
        setIsButtonDisabled(false);
      } else {
        setLoading(false);
        setIsButtonDisabled(false);
        Swal.fire({
          title: "Error",
          text: resp.msg,
          icon: "error",
        });
      }
    }
  };

  return (
    <>
      {loading && <Spinner />}
      <div className="container mb-2">
        <form className="row mt-4" onSubmit={saveClient}>
          <div className="col-sm-auto flex-column d-flex">
            <label className="form-control-plaintext" style={{ margin: "8px" }}>
              NOMBRE DE CLIENTE
            </label>
          </div>
          <div className="col-3 flex-column d-flex">
            <input
              type="text"
              className="form-control "
              placeholder="Introduce el nombre del cliente"
              style={{ margin: "0" }}
              name="nombreCliente"
              onChange={(e) => {
                setNombreCliente(e.target.value);
              }}
            />
          </div>
          <div className=" col-sm-auto flex-column d-flex">
            <label className="form-control-plaintext" style={{ margin: "8px" }}>
              LOGO DEL CLIENTE
            </label>
          </div>
          <div className="col-3 flex-column d-flex">
            <input
              type="file"
              placeholder="Imagen 500 X 200 PX"
              className="form-control"
              onChange={handleFileUpload}
            />
          </div>
          <div className="col-sm-auto">
            <button
              type="submit"
              className="btn btn-primary mb-3"
              disabled={isButtonDisabled}
            >
              Agregar nuevo cliente
            </button>
          </div>
        </form>

        <div className="row row-cols-1 row-cols-md-3 g-4 mt-5">
          {negocios &&
            negocios.map((n) => {
              return (
                <div className="col" key={n.negocio_id}>
                  <div className="card h-100">
                    <div
                      style={{
                        width: "100%",
                        height: "180px", // ← Tamaño fijo para todas las imágenes
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        padding: "10px",
                      }}
                    >
                      <img
                        src={
                          process.env.REACT_APP_API_URL_LOCAL +
                          `negocios/${n.negocio_id}/bg`
                        }
                        className="card-img-top mx-auto d-block"
                        alt={n.negocio_nombre}
                        style={{
                          width: "100%",
                          height: "100%",
                          objectFit: "contain", // ← Evita deformaciones
                        }}
                      />
                    </div>

                    <div className="card-body">
                      <h5 className="card-title">{n.negocio_nombre}</h5>
                    </div>

                    <div className="card-footer">
                      <small className="text-body-secondary">
                        Creado el {moment(n.createdAt).format("lll")}
                      </small>
                    </div>
                  </div>
                </div>
              );
            })}
        </div>
      </div>
    </>
  );
};
